function formatNumber(value) {
  let number = parseFloat(value);
  if (isNaN(number)) return "0.00";
  return number.toFixed(2);
}

function formatPhoneNumberWith855(phoneNumber) {
  if (!phoneNumber && phoneNumber !== 0) return phoneNumber;
  let cleaned = String(phoneNumber).replace(/\D/g, "");
  if (cleaned.startsWith("0")) cleaned = cleaned.slice(1);
  if (!cleaned.startsWith("855")) cleaned = "855" + cleaned;
  return cleaned.replace(/(\d{3})(?=\d)/g, "$1 ").trim();
}

function formatPhoneNumberWith0(phoneNumber) {
  if (phoneNumber === null || phoneNumber === undefined) return phoneNumber;
  const str = String(phoneNumber).trim();
  const digits = str.replace(/[^0-9]/g, "");

  if (!digits) {
    console.log("formatPhoneNumberWith0 1:", phoneNumber);
    return phoneNumber;
  }
  if (digits.startsWith("0")) {
    console.log("formatPhoneNumberWith0 2:", phoneNumber);
    return digits;
  }
  if (digits.startsWith("855")) {
    console.log("formatPhoneNumberWith0 3:", phoneNumber);
    return digits;
  }

  console.log("formatPhoneNumberWith0 4:", phoneNumber);
  return "0" + digits;
}

module.exports = {
  formatNumber,
  formatPhoneNumberWith855,
  formatPhoneNumberWith0,
};
